import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  CircularProgress,
} from "@mui/material";
import {
  fetchClassesAsync,
  selectAllClasses,
  selectClassesLoading,
  selectClassesError,
} from "../../../Slices/classesSlice";
import RegisterStudent from "./RegisterStudent";
import StudentsTable from "./StudentsTable";
import { getStudentsByClassId } from "../../../ApiService/ApiService";
import { Add } from "@mui/icons-material";

function StudentsSection() {
  const dispatch = useDispatch();
  const classes = useSelector(selectAllClasses);
  const classesLoading = useSelector(selectClassesLoading);
  const classesError = useSelector(selectClassesError);
  const [selectedClassId, setSelectedClassId] = useState("");
  const [showRegisterStudent, setShowRegisterStudent] = useState(false);
  const [students, setStudents] = useState({});
  const [actionComponent, setActionComponent] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchClassesAsync());
  }, [dispatch]);

  const fetchStudentsByClassId = async (selectedClassId) => {
    try {
      setLoading(true);
      const response = await getStudentsByClassId(selectedClassId);
      setStudents(response?.data);
    } catch (error) {
      console.error("Error fetching students:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (classes?.data?.length > 0) {
      setSelectedClassId(classes.data[0].id);
    }
  }, [classes]);

  useEffect(() => {
    if (selectedClassId) {
      fetchStudentsByClassId(selectedClassId);
    }
  }, [selectedClassId]);

  const handleClassChange = async (event) => {
    const selectedClassId = event.target.value;
    setSelectedClassId(selectedClassId);
  };

  const handleActionClick = (actionComponent) => {
    setActionComponent(actionComponent);
  };

  const renderMainContent = () => {
    if (showRegisterStudent) {
      return (
        <RegisterStudent
          setShowRegisterStudent={setShowRegisterStudent}
          fetchStudentsByClassId={fetchStudentsByClassId}
        />
      );
    } else if (actionComponent) {
      return <Box>{actionComponent}</Box>;
    } else {
      return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <FormControl size="small" sx={{ marginTop: 2, marginBottom: 2 }}>
            <InputLabel id="class">Class</InputLabel>
            <Select
              name="classId"
              label="Class"
              labelId="class"
              value={selectedClassId}
              onChange={handleClassChange}
              size="small"
              disabled={classesLoading || classesError}
              sx={{ width: "25%" }}
            >
              {classes?.data?.length > 0 ? (
                classes?.data?.map((classItem) => (
                  <MenuItem key={classItem?.id} value={classItem?.id}>
                    {`${classItem?.grade} ${
                      classItem?.section ? classItem?.section : ""
                    }`}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>Classes unavailable</MenuItem>
              )}
            </Select>
          </FormControl>
          <StudentsTable
            students={students}
            classes={classes}
            selectedClassId={selectedClassId}
            setActionComponent={setActionComponent}
            handleActionClick={handleActionClick}
            fetchStudentsByClassId={fetchStudentsByClassId}
          />
        </Box>
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showRegisterStudent || actionComponent ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{
            color: "black",
            fontWeight: 600,
            fontSize: 22,
          }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Students
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowRegisterStudent(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Register Student
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default StudentsSection;
